import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { FDBox } from '@facet-wealth/design';
import ScenarioChartContainer from './ScenarioChartContainer';
import { ScenarioChartProvider } from './ScenarioChartContext';

export const CURRENT_TIMEFRAME = 'current';
export const MAX_TIMEFRAME = 'max';
export const TIMEFRAME_QP = 'timeFrame';

const ScenarioChart = ({
  chartDataTimeframe,
  hasNoTitle,
  height,
  isCollapsible,
  setChartDataTimeframe,
  isInflationAdjustable,
  isMultiChart,
  onLoadSucceeded,
  onLoadFailed,
  test,
  ...props
}) => {
  const [localTimeframe, setLocalTimeframe] = React.useState(
    chartDataTimeframe,
  );

  return (
    <ScenarioChartProvider
      {...props}
      chartDataTimeframe={
        setChartDataTimeframe ? chartDataTimeframe : localTimeframe
      }
      setChartDataTimeframe={setChartDataTimeframe ?? setLocalTimeframe}
      onLoadSucceeded={onLoadSucceeded}
      onLoadFailed={onLoadFailed}
    >
      <FDBox
        {...dataAttrs(test)}
      >
        <ScenarioChartContainer
          hasNoTitle={hasNoTitle}
          height={height}
          isCollapsible={isCollapsible}
          isInflationAdjustable={isInflationAdjustable}
          isMultiChart={isMultiChart}
        />
      </FDBox>
    </ScenarioChartProvider>
  );
};

ScenarioChart.defaultProps = {
  broadcastTimeframe: undefined,
  chartDataTimeframe: MAX_TIMEFRAME,
  hasNoTitle: false,
  height: 380,
  isCollapsible: false,
  isInflationAdjustable: false,
  isMultiChart: false,
  setChartDataTimeframe: undefined,
  test: 'scenario-chart',
  onLoadSucceeded: () => {},
  onLoadFailed: () => {},
};

ScenarioChart.propTypes = {
  broadcastTimeframe: PropTypes.func,
  chartDataTimeframe: PropTypes.string,
  hasNoTitle: PropTypes.bool,
  height: PropTypes.number,
  isCollapsible: PropTypes.bool,
  isInflationAdjustable: PropTypes.bool,
  isMultiChart: PropTypes.bool,
  relationship: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
  setChartDataTimeframe: PropTypes.func,
  onLoadSucceeded: PropTypes.func,
  onLoadFailed: PropTypes.func,
  test: PropTypes.string,
};

export default ScenarioChart;
